import { Outlet } from 'react-router-dom';
import { AuthenticatedLayout } from '../AuthenticatedLayout/AuthenticatedLayout.component';

export const RedirectLayout = () => (
  <AuthenticatedLayout>
    <Outlet />
  </AuthenticatedLayout>
);
